import { SVGProps } from "react"

export function IconHandshake(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500" {...props}>
      <defs>
        <clipPath id="a">
          <path fill="none" d="M0 0h500v500H0z" />
        </clipPath>
      </defs>
      <g clipPath="url(#a)">
        <circle cx="246.283" cy="254.021" r="177.173" fill="#c5d3d6" />
        <path
          fill="#00515f"
          stroke="#1d1d1b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.778"
          d="M165.536 62.689c-14.27-9.691-34.773-9.103-57.525 4.034-42.941 24.792-77.636 84.892-77.496 134.235.06 21.149 6.509 36.889 17.242 46.02l38.96 24.025L195.663 81.28l-30.126-18.591Z"
        />
        <path
          fill="#00515f"
          stroke="#1d1d1b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.778"
          d="M137.558 84.904c-42.941 24.792-77.636 84.892-77.496 134.235s35.061 69.244 78.003 44.451 77.642-84.889 77.502-134.232-35.067-69.247-78.008-44.455"
        />
        <path
          fill="#eef4f6"
          stroke="#1d1d1b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.778"
          d="M133.229 108.438c-30.834 17.802-55.747 60.957-55.647 96.388s25.176 49.721 56.01 31.919 55.751-60.955 55.651-96.386-25.18-49.723-56.014-31.921"
        />
        <path
          fill="#fff"
          stroke="#1d1d1b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.778"
          d="M269.951 391.703c10.583.115 11.999-1.974 15.418-8.547 20.663-.132 21.297-7.322 24.427-11.924l12.349-197.003c1.102-6.204-8.431-23.572-10.493-28.153-2.061-4.581-5.268-18.782-29.548-24.967s-70.548-15.805-112.314-6.872-63.598 44.665-69.554 68.258c-5.955 23.592-.792 41.491 3.789 50.882l85.81 135.296 28.832 22.823a15.66 15.66 0 0 0 7.465 3.243c9.03 1.336 29.874 4.359 33.621 4.359 4.81 0 7.424-1.409 10.196-7.395Z"
        />
        <path
          fill="#fff"
          stroke="#1d1d1b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.778"
          d="m375.706 219.581-3.742-1.158a28.73 28.73 0 0 1-14.346-10.017h0a124 124 0 0 0-17.318-18.435l-46.441-40.27a27.35 27.35 0 0 0-21.858-6.399l-53.569 7.809a27.35 27.35 0 0 0-19.305 12.665l-14.092 22.764a83 83 0 0 0-5.347 10.15l-9.72 22.042a1.84 1.84 0 0 0 1.103 2.541l8.649 2.757a26.38 26.38 0 0 0 28.202-8.156l14.055-16.714 43.119 5.497s.344 21.989.859 27.486 2.233 23.535 31.437 45.868c10.084 8.454 17.083 26.653 17.083 26.653l64.288-60.324-3.059-24.758Z"
        />
        <path
          fill="#fff"
          stroke="#1d1d1b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.083"
          d="m184.042 194.851 4.796.286c3.675.219 5.667 4.401 3.523 7.393l-11.241 15.685a8.94 8.94 0 0 1-7.314 3.731h0c-3.776-.021-6.387-3.783-5.086-7.327l8.013-15.599a7.7 7.7 0 0 1 7.308-4.168Z"
        />
        <path
          fill="#00515f"
          stroke="#1d1d1b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.778"
          d="M441.762 210.084c-14.27-9.691-34.773-9.103-57.525 4.034-42.941 24.792-77.636 84.892-77.496 134.235.06 21.149 6.509 36.889 17.242 46.02l38.96 24.025 108.946-189.723-30.126-18.591Z"
        />
        <path
          fill="#00515f"
          stroke="#1d1d1b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.778"
          d="M413.785 232.299c-42.941 24.792-77.636 84.892-77.496 134.235s35.061 69.244 78.003 44.451 77.642-84.889 77.502-134.232-35.067-69.247-78.008-44.455"
        />
        <path
          fill="#fff"
          stroke="#1d1d1b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.778"
          d="M123.232 289.962c-6.026-.635-9.232-4.482-16.67-13.715s-5.001-14.619-4.488-26.032.641-20.646 12.696-20.775 23.468 10.131 23.981 18.338 0 21.767 0 21.767l-15.518 20.417Z"
        />
        <path
          fill="#fff"
          stroke="#1d1d1b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.778"
          d="M137.09 319.335c-6.026-.635-9.232-4.482-16.67-13.715s-5.001-14.619-4.488-26.032.641-20.646 12.696-20.775 23.468 10.131 23.981 18.338 0 21.767 0 21.767l-15.518 20.417Z"
        />
        <path
          fill="#fff"
          stroke="#1d1d1b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.778"
          d="M153.015 344.014c-5.382-.567-8.245-4.003-14.888-12.249s-4.467-13.056-4.008-23.249.573-18.439 11.338-18.553 20.958 9.048 21.416 16.377c.458 7.33 0 19.44 0 19.44l-13.859 18.234Z"
        />
        <path
          fill="#fff"
          stroke="#1d1d1b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.778"
          d="M189.836 368.672c-5.497-11.872-3.436-15.919-3.779-23.249s-9.277-19.698-20.443-19.527c-11.166.172-12.197 10.307-12.712 20.271s1.864 17.375 11.853 22.504c6.356 3.264 25.081 0 25.081 0Z"
        />
        <path
          fill="#fff"
          stroke="#1d1d1b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.083"
          d="m155.65 333.025 12.483 8.475s3.321 17.637-6.242 12.598-6.242-21.073-6.242-21.073Zm-21.166-36.171 13.229 9.48s3.099 19.109-7.075 13.414-6.154-22.894-6.154-22.894m-17.334-31.099 11.604 7.788s3.709 23.195-5.732 17.752c-9.056-5.221-5.872-25.539-5.872-25.539Zm-14.062-27.028 10.778 7.902s2.535 22.692-5.384 17.249c-7.596-5.221-5.394-25.152-5.394-25.152Z"
        />
        <path
          fill="none"
          stroke="#1d1d1b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.778"
          d="M285.369 383.156c-.667.004-1.525 0-2.233-.011-22.676-.344-35.389-10.307-38.996-14.068-3.608-3.761-34.353-33.861-34.353-33.861m-12.718 17.006s25.253 25.081 29.891 28.345 12.751 9.277 32.831 10.651c4.095.28 7.448.455 10.159.484m-44.535-75.384s42.947 40.199 44.665 41.917 10.213 11.184 39.121 10.832m-59.392-72.046s34.816 33.442 38.71 36.877 10.561 7.559 18.222 10.536"
        />
      </g>
    </svg>
  )
}
